import useSWR from "swr";
import { getClientFileSummaries } from "../services/file-monitor-service";
import { ClientWithFrequency, UseFilesModel } from "../types";

export const FILE_MONITOR_CLIENTS_KEY = "/file-monitor/clients";

// Loads the client list. It only carries each client's file count and
// frequency; a client's files are loaded separately, a page at a time, when
// it is opened (see useClientFiles).
export const useFileMonitor = (): UseFilesModel => {
  const { data, error, mutate } = useSWR(
    FILE_MONITOR_CLIENTS_KEY,
    getClientFileSummaries,
  );

  const clients: ClientWithFrequency[] | undefined = data?.results
    ? data.results
        .map((summary) => ({
          ...summary.clientInformation,
          frequency: summary.frequency,
          fileCount: summary.fileCount,
        }))
        .filter((client) => client.enabled && !client.deleted)
    : undefined;

  const getFileCount = (clientId: number): number =>
    data?.results.find((s) => s.clientInformation.id === clientId)?.fileCount ??
    0;

  return {
    clients,
    isLoading: !error && !data,
    error,
    mutate,
    getFileCount,
  };
};
